<template>
  <div class="input-area">
    <label
      for="comment-input"
      class="input-area__label"
    >{{ label }}</label>
    <textarea
      id="comment-input"
      v-model="innerValue"
      class="input-area__field"
      rows="3"
      :placeholder="placeholder"
      @input="onInput"
    />
  </div>
</template>

<script lang="ts">
import { ref } from 'vue'

export default defineNuxtComponent({
  props: {
    label: { type: String, default: '' },
    placeholder: { type: String, default: 'Comentario...' },
    modelValue: { type: String, default: '' },
  },

  setup(props, {emit}) {
    const innerValue = ref(props.modelValue)

    function onInput() {
      emit('update:modelValue', innerValue.value)
    }

    return {
      innerValue,
      onInput
    }
  },
})
</script>

<style lang="scss" scoped>
.input-area {
  &__label {
    @apply inline-block mb-2;
    @apply text-spl-gray-4;
  }

  &__field {
    @apply resize-none;
    @apply block;
    @apply w-full;
    @apply px-3;
    @apply py-1.5;
    @apply text-base;
    @apply font-normal;
    @apply text-gray-700;
    @apply bg-white;
    @apply bg-clip-padding;
    @apply border;
    @apply border-solid;
    @apply border-gray-300;
    @apply rounded;
    @apply transition ease-in-out m-0;

    @apply focus:text-gray-700;
    @apply focus:bg-white;
    @apply focus:border-gray-600;
    @apply focus:outline-none;
  }
}
</style>
